import type { AiAssistant } from "../interfaces";

/**
 * Stub AI assistant — Phase 6a.5 placeholder. isAvailable() always returns
 * false so UI elements (AI button in TopNav, suggestion buttons in form)
 * stay disabled. Phase 10 swaps this for the real Anthropic-backed
 * implementation behind the same interface.
 */
export class StubAiAssistant implements AiAssistant {
  isAvailable(): boolean {
    return false;
  }

  // eslint-disable-next-line require-yield
  async *chat(): AsyncIterable<string> {
    throw new Error("AI Assistant not available in Phase 6a");
  }

  async suggestDiscountRate(): Promise<null> {
    return null;
  }

  async suggestFxRate(): Promise<null> {
    return null;
  }
}
